// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"5457f0b7","247":"1d748e9d","284":"7282a864","422":"8e0e607e","627":"df46f5e7","683":"a77c0d48","867":"c8f9aab1","923":"008b84f1","938":"5579a723"}[chunkId] + ".chunk.js";
};